export default __webpack_public_path__ + "static/media/img-email-footer.065a65f4.png";